module.exports = __webpack_public_path__ + "media/images/application/logolepoulpe-c8b51056c93a47a2f974ee2daa96b52c.gif";